import { render, staticRenderFns } from "./SurveysNew.vue?vue&type=template&id=23af8c78&"
import script from "./SurveysNew.vue?vue&type=script&lang=js&"
export * from "./SurveysNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports